<template>
  <div class="timeLine">
    <p>{{ props.title }}</p>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  title: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: ''
  }
})
</script>

<style scoped lang="less">
.timeLine {
  margin: 10px;
}
</style>
